export type HeroIcon = React.ForwardRefExoticComponent<
  Omit<React.SVGProps<SVGSVGElement>, "ref"> & {
    title?: string;
    titleId?: string;
  } & React.RefAttributes<SVGSVGElement>
>

export type Response = {
  question_id: number
  option_choice_id: number
}

export type ResponseData = {
  responses: Response[]
}

export type OptionChoice = {
  option_choice_id: number
  option_choice_name: string
  option_group_id: number,
  option_group_index: number,
  likert_score: number
}

export type Question = {
  input_type_id: number
  option_group_id: number
  page_number: number
  question_id: number
  question_title: string
}

export type User = {
  survey_key: string | null
  languge_id: number | null
  age_id: number | null
  years_experience_id: number | null
  gender_id: number | null
}

export type Admin = {
  email: string | null
}

export type CompanyResource = {
  company_resource_id: number,
  company_id: number,
  company_resource_name: string,
  company_resource_description: string | null,
  email: string | null,
  phone: string | null,
  link: string | null,
  link_text: string | null
}

export type Persona = {
  test_persona_id: number,
  name: string
}

//// Results /////
export type ProcessedResponse = {
  question_id: number;
  section_id: number;
  domain_name: string;
  factor_name: string;
  value: number;
}

export type ResultQuestion = {
  id: string;
  text: string;
  performanceLevel: "Strong" | "Good" | "Needs Work";
  category: "Thriving" | "Stable" | "Needs Focus";
  value: number;
}

export type Factor = {
  name: string;
  performanceLevel: "Strong" | "Good" | "Needs Work";
  category: "Thriving" | "Stable" | "Needs Focus";
  questions: ResultQuestion[];
}

export type DomainResult = {
  domain: string;
  performanceLevel: "Strong" | "Good" | "Needs Work";
  category: "Thriving" | "Stable" | "Needs Focus";
  factors: Factor[];
}

export const BYU_COMPANY_IDS = [98, 99, 100];